import { Table } from "../../../../components/ui/Table";
import { formatName } from "../../../../services/functions";
import {
  formatCurrency,
  formatNumber,
  formatDateTime,
} from "../helpers";
import { ResultyStatusBadge } from "./ResultyStatusBadge";

export function ResultyRow({ attempt }) {
  return (
    <Table.Line>
      <Table.Item>{formatNumber(attempt.opportunity?.daysSinceLastAppointment)} {attempt.opportunity?.daysSinceLastAppointment === 1 ? "dia" : "dias"}</Table.Item>
      <Table.Item>
        <div className="flex flex-col">
          <strong>{formatName(attempt.customerName || "Cliente não informado")}</strong>
          <span className="text-xs text-gray-500">
            Pet: {formatName(attempt.sourcePetName || "—")}
            {attempt.activePetsCount > 1 ? ` · ${attempt.activePetsCount} pets ativos` : ""}
          </span>
        </div>
      </Table.Item>
      <Table.Item>
        <strong> {formatNumber(attempt.contactCount)}</strong> {attempt.contactCount === 1 ? 'contato' : 'contatos'}
      </Table.Item>
      <Table.Item>
        {formatDateTime(attempt.firstContactAt)}
      </Table.Item>
      <Table.Item>
        {formatDateTime(attempt.lastContactAt)}
      </Table.Item>
      <Table.Item><ResultyStatusBadge status={attempt.status} /></Table.Item>
      <Table.Item>{formatCurrency(attempt.totals?.serviceRevenue)}</Table.Item>
      <Table.Item>{formatCurrency(attempt.totals?.productRevenue)}</Table.Item>
      <Table.Item>
        <div className="flex flex-col">
          <strong>{formatCurrency(attempt.totals?.totalRevenue)}</strong>
          <span className="text-xs text-gray-500">
            Até agendar: {formatNumber(attempt.contactsUntilSchedule)} contato(s)
          </span>
        </div>
      </Table.Item>
    </Table.Line >
  );
}
